import React from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import "./ManufacturerSliderArrows.scss";

const ManufacturerSliderArrows = (props) => {
    const { previousSlide, nextSlide } = props;
    return (
        <div className="arrows">
            <div className="arrow-left" onClick={previousSlide}>
                <FiChevronLeft />
            </div>
            <div className="arrow-right" onClick={nextSlide}>
                <FiChevronRight />
            </div>
        </div>
    );
};

export default ManufacturerSliderArrows;
